module.exports = __webpack_public_path__ + "img/expand-group.93f1bafc.svg";